export const getGMT = (offsetMm: number): string => {
  const offsetHours = Math.abs(offsetMm / 60);
  const offsetMinutes = Math.abs(offsetMm % 60);
  const getVal = (num: number): string => (num < 10 ? `0${num}` : `${num}`);
  const hh = getVal(Math.floor(offsetHours));
  const mm = getVal(Math.floor(offsetMinutes));
  const prefix = offsetMm < 0 ? '-' : '+';
  return `${prefix}${hh}${mm}`;
};

export const normalizeTime = (value: string): string => {
  value = String(value);
  if (value.length === 1) {
    return `0${value}:00`;
  }
  if (value.length === 2) {
    return `${value}:00`;
  }
  return value;
};
